import "regenerator-runtime/runtime";
import _asyncToGenerator from "F:\\vft-activities\\d2d\\node_modules\\@babel\\runtime-corejs2/helpers/esm/asyncToGenerator";
import _objectSpread from "F:\\vft-activities\\d2d\\node_modules\\@babel\\runtime-corejs2/helpers/esm/objectSpread";
import _Array$from from "F:\\vft-activities\\d2d\\node_modules\\@babel\\runtime-corejs2/core-js/array/from";
import _Promise from "F:\\vft-activities\\d2d\\node_modules\\@babel\\runtime-corejs2/core-js/promise";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import SharePop from '../../components/SharePop';
import VipIcon from '../../components/VipIcon';
import { env, tenvideo, url } from '@tencent/vft-common';
import { PropertyBelong } from './util';
import awardAndShareMixin from './awardAndShareMixin';
import { mapState, mapGetters, mapActions } from 'vuex';

function img2base64(url, crossOrigin) {
  return new _Promise(function (resolve) {
    var img = new Image();

    img.onload = function () {
      try {
        var c = document.createElement('canvas');
        c.width = img.naturalWidth;
        c.height = img.naturalHeight;
        var cxt = c.getContext('2d');
        cxt.drawImage(img, 0, 0); // 得到图片的base64编码数据

        resolve(c.toDataURL('image/png'));
      } catch (e) {
        window.console.error(e);
        resolve(url);
      }
    };

    img.onerror = function (e) {
      window.console.error(e);
      resolve(url);
    };

    crossOrigin && img.setAttribute('crossOrigin', crossOrigin);
    img.src = url;
  });
}

function filterEmoji(str, len) {
  var length = 0,
      strArr = _Array$from(str),
      // ES6的Array.from支持代理对的解析
  strArrlen = strArr.length,
      result = '';

  for (var i = 0; i < strArrlen; i++) {
    var item = strArr[i];
    length++;

    if (escape(item).length > 4) {
      // 中文或表情符编码后长度大于4，按两个字符的宽度计算
      length++;
    }

    result = result.concat(item);

    if (length >= len) {
      if (i === strArrlen - 1) {
        return result;
      }

      result = result.concat('...');
      return result;
    }
  }

  if (length < len) {
    return str;
  }
}

export default {
  mixins: [awardAndShareMixin],
  props: ['item', 'eggImg'],
  settingKey: '碰蛋结果分享',
  setting: {
    分享二维码: {
      type: 'image',
      default: '//puui.qpic.cn/vupload/0/20181209_1544332612134_pge6q117lb.png/0'
    },
    分享标题: {
      type: 'expression',
      default: '${item.my.name}在腾讯视频6周年对对碰活动中和好友碰出了${item.my.property_name}',
      variables: ['item.my.name', 'item.other.name', 'item.my.property_name']
    },
    分享描述: {
      type: 'expression',
      default: '${item.my.name}在腾讯视频6周年对对碰活动中和好友碰出了${item.my.property_name}',
      variables: ['item.my.name', 'item.other.name', 'item.my.property_name']
    },
    分享朋友圈标题: {
      type: 'expression',
      default: '${item.my.name}在腾讯视频6周年对对碰活动中和好友碰出了${item.my.property_name}',
      variables: ['item.my.name', 'item.other.name', 'item.my.property_name']
    },
    分享图: {
      type: 'image',
      default: '//puui.qpic.cn/vupload/0/20181211_1544517618070_rwuki7wxa8.png/0'
    },
    分享链接: {
      type: 'url',
      default: '//film.qq.com/weixin/v3/d2d-cny/index.html?ptag=share.xuanyao'
    }
  },
  data: function data() {
    return {
      myHead: this.item.my.headurl,
      otherHead: this.item.other.headurl,
      PropertyBelong: PropertyBelong
    };
  },
  components: {
    SharePop: SharePop,
    VipIcon: VipIcon
  },
  computed: _objectSpread({}, mapGetters(['userInfo', 'payVip', 'shareLogo']), {
    isStarCode: function isStarCode() {
      return this.item.other.type === 5;
    },
    // 奖品下方只展示一个人头像昵称
    oneUser: function oneUser() {
      if (this.isStarCode) {
        return false;
      } else if (this.item.property_belong === PropertyBelong.Guest) {
        return this.item.my;
      } else if (this.item.property_belong === PropertyBelong.Master) {
        return this.item.other;
      }

      return false;
    }
  }),
  mounted: function () {
    var _mounted = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee() {
      var _this = this;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return img2base64(url.buildUrl(this.myHead, {
                _: new Date().getTime()
              }), true);

            case 2:
              this.myHead = _context.sent;
              _context.next = 5;
              return img2base64(url.buildUrl(this.otherHead, {
                _: new Date().getTime()
              }), true);

            case 5:
              this.otherHead = _context.sent;
              this.$nextTick(function () {
                _this.$refs.sharePop.shareHandler();

                _this.share.setShare({
                  imgUrl: _this.setting.分享图,
                  title: _this.setting.分享标题(_this),
                  desc: _this.setting.分享描述(_this),
                  timeLineTitle: _this.setting.分享朋友圈标题(_this),
                  link: _this.setting.分享链接
                });
              });

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function mounted() {
      return _mounted.apply(this, arguments);
    }

    return mounted;
  }(),
  filters: {
    filterEmoji: filterEmoji
  },
  methods: {
    filterEmoji: filterEmoji,
    hide: function hide() {
      this.$emit('hide');
    },
    bgImgLoad: function bgImgLoad() {
      var _this2 = this;

      window.setTimeout(function () {
        _this2.$refs.sharePop.showImage();
      }, 100);
    }
  }
};